import { Grid } from "@mui/material";
import { ITableHeader } from "src/interfaces/table";
import { FONTS_WEIGHTS } from "src/global/theme/fonts";
import { TEXT_ALIGN } from "src/components/Text";

import { styles } from './styles';

export interface TableHeaderProps {
  tableHeaders: ITableHeader[];
  textAlign: TEXT_ALIGN;
  whiteSpace: string;
  overflow: string;
  fontWeight: FONTS_WEIGHTS;
}

const TableHeader = ({ tableHeaders, textAlign, whiteSpace, overflow, fontWeight }: TableHeaderProps) => {
  const { classes } = styles();

  return (
    <Grid data-testid={'table-header'} container className={classes.tableHeader}>
      {tableHeaders.map((header) => (
        <Grid
          item
          key={header.id}
          xs={header.xs}
          textAlign={textAlign}
          whiteSpace={whiteSpace}
          overflow={overflow}
          fontWeight={fontWeight}
        >
          {header.name}
        </Grid>
      ))}
    </Grid>
  );
};

export default TableHeader;